import { Uploader, ImageWithText } from "../../components";
import React, { useState, useEffect } from "react";
import Upload from "../../assets/icons/svg/uploadImg.svg";
import { Upload as UploadIcon } from "lucide-react";
import styles from "../../scss/imageupload.module.scss";
import noImage from "../../assets/icons/svg/no-image.svg";
import { toast } from "../../components";

interface ImageUploadProps {
  id?: string;
  registerMedia: any;
  setSelectedImage: (file: any) => void;
  callbackRef: any;
  type?: string;
  logo?: string;
  hasBaseUrl?: boolean;
  setIsLoading: (isLoading: {
    error: boolean;
    success: boolean;
    loading: boolean;
  }) => void;
  handleImageUploadUrl?: (imageUrl: string) => void;
  isPreset?: boolean;
  isLoading?: { error: boolean; success: boolean; loading: boolean };
  logoRef?: any;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  id,
  registerMedia,
  setSelectedImage,
  callbackRef,
  type,
  logo,
  hasBaseUrl,
  setIsLoading,
  handleImageUploadUrl,
  isPreset = false,
  isLoading = { error: false, success: false, loading: false },
  logoRef,
}) => {
  const [currentImage, setCurrentImage] = useState(
    hasBaseUrl && logo ? logo : Upload
  );
  const [hovered, setHovered] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (hasBaseUrl && logo) {
      setCurrentImage(logo);
    } else if (!hasBaseUrl && logo) {
      setLoader(true);
    }
  }, [logo, hasBaseUrl, isLoading]);

  const onFileEvent = (event: string, data: any, cb?: any): any => {
    if (event === "fileAdded") {
      const file = data.file;

      if (file.file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target) {
            const imageData = e.target.result as string;
            setCurrentImage(e.target.result as string);
          }
        };

        reader.readAsDataURL(file.file);
      }

      file.isShorts = data.isShorts;
      file.name = "logo";
      file.type = type;
      setSelectedImage(file);

      callbackRef.current = cb;
    } else if (event === "fileProgress") {
      const file = data.file;
      const progress = Math.round(file.progress(false) * 1000) / 10;
      setIsLoading &&
        setIsLoading({
          error: false,
          success: false,
          loading: true,
        });
    } else if (event === "fileSuccess") {
      const response = JSON.parse(data.response);

      if (response?.data?.url?.length > 0) {
        handleImageUploadUrl?.(response?.data?.url);
      }

      if (logoRef?.current) {
        logoRef.current.value = response.data.id || "";
        logoRef.current.baseurl = response.data.baseurl || "";
      }

      setIsLoading &&
        setIsLoading({
          error: false,
          success: true,
          loading: false,
        });
    } else if (event === "fileError") {
      const { file, error } = data;
      setIsLoading &&
        setIsLoading({
          error: true,
          success: false,
          loading: false,
        });
      toast.fail(error);
      setSelectedImage((prevFile: any) => ({
        ...prevFile,
        status: "error",
        error: error,
      }));
    }
  };

  return (
    <>
      {/* <div>
        <label className="form-label py-1">Logo</label>
      </div> */}
      <Uploader
        id={"Thumb"}
        onFileEvent={onFileEvent}
        datatype={"IMAGE"}
        size={"auto"}
        width="149px"
        disabled={isLoading?.loading}
      >
        {isPreset ? (
          <div
            className={`card catRow border p-3 d-flex flex-column align-items-center justify-content-center ${
              isLoading?.loading ? "disabled" : "pointer"
            }`}
            style={{
              flex: "0 0 148px",
              height: "90px",
              opacity: isLoading?.loading ? 0.7 : 1,
              pointerEvents: isLoading?.loading ? "none" : "auto",
            }}
          >
            <UploadIcon size={24} className="mb-2" />
            {isLoading?.loading && (
              <div
                className="d-flex align-items-center justify-content-center h-100"
                id="loader"
              >
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
            Upload
          </div>
        ) : (
          <>
            {currentImage === "no image" ? (
              <ImageWithText
                imageUrl={<Upload />}
                text="Upload Logo"
                showText={true}
              />
            ) : (
              <div
                className="border rounded ratio ratio-16x9 pointer"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
              >
                {loader ? (
                  <div
                    className="d-flex align-items-center justify-content-center h-100"
                    id="loader"
                  >
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <img
                    src={currentImage}
                    alt="Preview"
                    className="bg-light"
                    style={{ objectFit: "contain" }}
                  />
                )}
                {hovered && (
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100 d-flex"
                    style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
                  >
                    <button
                      className={`btn btn-primary m-auto ${styles["custom-upload-btn"]}`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      {logo ? "Re-Upload" : "Upload"}
                    </button>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </Uploader>
    </>
  );
};

export default ImageUpload;
